<template>
  <div class="wrapper" style="background-color: white;">
    <div class="login-top" style="width: 1300px;margin: 0 auto;">
      <div style="height: 30px;background-color: white; ">
        <div style="margin-top: 10px;">
          <img src="../../assets/image/logo.png" width="160px" height="60px" style="vertical-align:middle;"/>
          <span style="width: 400px;font-size: 20px;font-weight: bold;color:#3598db ;">南方竞价平台</span>
        </div>
        <div style="float:right;margin-top: -44px;width: 380px;font-size: 12px;font-family:Microsoft YaHei;text-align: right;">
          <span style="padding-left:30px;">{{DateStr}}</span>
          <br>
          <a style=
               "text-decoration:none;color:#666;margin-right:10px;" href="#" class="hrefs"
             onclick="this.style.behavior='url(#default#homepage)';this.setHomePage('http://www.verygosoft.com');">
            <img src="../../assets/image/home.png" width="20px" height="20px"
                 style="vertical-align:middle;"/><span>设为首页</span></a>|
          <a style=
               "text-decoration:none;color:#666;margin-right: 10px;"
             href="javascript:window.external.AddFavorite('http://www.verygosoft.com', '南方竞价平台')">
            <img src="../../assets/image/collect.png" width="20px" height="20px" style="vertical-align:middle;"/>加入收藏</a>|
          <a style=
               "text-decoration:none;color:#666;"
             href="#"><img src="../../assets/image/help.png" width="20px" height="20px"
                           style="vertical-align:middle;"/>帮助中心</a>
          <br></br>
        </div>
      </div>
      <div class="login-topBg">
        <div class="login-topBg1">
          <div class="login-topStyle">
            <div class="login-topStyle3" id="loginStyle"
                 style="margin-top: 75px;padding: 22px 30px 22px 25px;">
              <h3>用户登录</h3>
              <el-form :model="loginForm" :rules="loginRules" autoComplete="on" ref="loginForm" label-width="80px">
                <el-form-item label="用户名" prop="usercode" class="delu-box">
                  <el-input v-model="loginForm.usercode" v-focus placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="密 码" prop="password" class="login-password delu-box">
                  <el-input v-model="loginForm.password" placeholder="请输入密码" type="password"
                            @keyup.native.enter="handleLogin" ></el-input>
                </el-form-item>
                <el-form-item label=" " class="delu-box">
                  <el-button type="primary" @click.native.prevent="handleLogin"
                             style="float: left;">登录
                  </el-button>
                  <el-button @click.native.prevent="handleReset" style="float: right;">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="footer"><span class="footerText"> © 2017-2022 广州市元正有限公司版权所有 <a href="http://www.beian.miit.gov.cn" target="_blank">粤ICP备18027026号</a></span></div>
      <div style="text-align: center">
        为正确浏览本站页面，达到最佳的阅读和视觉效果，请选择使用以下浏览器:
        <a href="http://browser.qq.com/" target="_blank">QQ浏览器(请选择极速模式)</a>
        <a href="https://www.google.cn/chrome/browser/desktop/index.html" target="_blank">谷歌浏览器(Google Chrome)</a>
        <a href="http://www.firefox.com.cn/" target="_blank">火狐浏览器(Mozilla Firefox)</a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {isvalidUsername} from '@/utils/validate'
import config from '../../config/default'
import Md5 from '../../assets/js/md5'
import request from '@/utils/request'
export default {
  data () {
    return {
      loginForm: {
        usercode: '',
        password: ''
      },
      loginRules: {
        usercode: [{ required: true, trigger: 'blur'}],
        password: [{ required: true, trigger: 'blur'}]
      },
      passwordType: 'password',
      DateStr: '',
      loading: false,
      showDialog: false
    }
  },
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector('input').focus()
      }
    }
  },
  created() {
    this.getNowDate()
  },
  methods: {
    getNowDate () {
      let today = new Date()
      let day
      if (today.getDay() === 0) {
        day = '星期日'
      }
      if (today.getDay() === 1) day = '星期一'
      if (today.getDay() === 2) day = ' 星期二'
      if (today.getDay() === 3) day = ' 星期三'
      if (today.getDay() === 4) day = ' 星期四'
      if (today.getDay() === 5) day = ' 星期五'
      if (today.getDay() === 6) day = ' 星期六'
      this.DateStr = (today.getFullYear()) + '年' + (today.getMonth() + 1) + '月' + today.getDate() + '日' + day
    },
    handleReset () {
      this.loginForm.usercode = ''
      this.loginForm.password = ''

    },
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loginForm.password = Md5.md5(this.loginForm.password)
           request ({
                  url: '/xtgl/user/login',
                  method: 'post',
                  data: this.loginForm
            }).then(data => {
              console.log(data)
                this.$store.commit('set_user_info', data)
                this.loading = false
                this.$router.push({path: '/'})
            })
        }
      })
    }
  }
}
</script>
<style scoped>
  .login {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .el-card {
    display: block;
    height: auto;
    padding: 0 30px;
  }
</style>

